var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 5.83331L10.8987 10.412C13.8453 12.0849 15.155 12.0849 18.1017 10.412L26.1668 5.83331",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 22.75C12.2061 22.7429 11.6615 22.7325 11.1155 22.7188C7.44221 22.6265 5.60559 22.5803 4.28595 21.2548C2.9663 19.9294 2.92816 18.1402 2.85189 14.5617C2.82737 13.411 2.82736 12.2672 2.85188 11.1165C2.92816 7.53801 2.96629 5.74875 4.28594 4.42331C5.60559 3.09787 7.44221 3.05171 11.1155 2.95936C13.3793 2.90245 15.621 2.90247 17.8849 2.95938C21.5581 3.05172 23.3947 3.09789 24.7143 4.42333C26.0341 5.74876 26.0722 7.53802 26.1484 11.1165C26.1597 11.6463 26.1658 11.8959 26.1667 12.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 19.8333C22.6665 20.7998 21.883 21.5833 20.9165 21.5833C19.95 21.5833 19.1665 20.7998 19.1665 19.8333C19.1665 18.8668 19.95 18.0833 20.9165 18.0833C21.883 18.0833 22.6665 18.8668 22.6665 19.8333ZM22.6665 19.8333V20.4166C22.6665 21.3831 23.45 22.1666 24.4165 22.1666C25.383 22.1666 26.1665 21.3831 26.1665 20.4166V19.8333C26.1665 16.9338 23.816 14.5833 20.9165 14.5833C18.017 14.5833 15.6665 16.9338 15.6665 19.8333C15.6665 22.7328 18.017 25.0833 20.9165 25.0833",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconBlack);
export default __webpack_public_path__ + "static/media/Email_Icon_Black.7a17dd9dc3a4087f292b18ea91459fa5.svg";
export { ForwardRef as ReactComponent };